module.exports = __webpack_public_path__ + "img/greenTickBack.2781de47.svg";